// ==============================|| OVERRIDES - TABLE PAGINATION ||============================== //

// The "Rows per page" label and "1-13 of 513" text use body2 (0.75rem), but MUI
// renders the select value ("10", "25", ...) with the root's inherited 0.875rem,
// leaving it visibly larger. Pin the select and its menu items to body2 to match.
// Applies to grids using the default TablePagination footer; DataGridWrapper's
// paging mode renders its own GridPaginationFooter, styled in that component.
export default function TablePagination(theme) {
  const { fontSize } = theme.typography.body2

  return {
    MuiTablePagination: {
      styleOverrides: {
        select: { fontSize },
        menuItem: { fontSize }
      }
    }
  }
}
